export class Test {
  constructor ({ id = null, name = null, start = new Date(), end = null, countryId = '',
    breakout = null, percentage = 0, status = null, sendNotification = false, carrierId = null, result = null } = {}) {
    this.id = id
    this.name = name
    this.start = start
    this.end = end
    this.countryId = countryId
    this.breakout = breakout
    this.percentage = percentage
    this.status = status
    this.sendNotification = sendNotification
    this.carrierId = carrierId
    this.result = result

    this.isCancelled = this._isCancelled()
    this.isFinalised = this._isFinalised()
    this.isOngoing = this._isOngoing()
  }

  _isOngoing () {
    var now = new Date()
    return (this.end > now) && !this.isCancelled
  }

  _isCancelled () {
    // 0 = active, 1 = cancelled
    return this.status === 1
  }

  _isFinalised () {
    if (this.isCancelled) {
      return true
    }
    if (this.end !== null) {
      var now = new Date()
      return this.end < now || this.isCancelled
    }
    return false
  }
}

export function createTest (data) {
  return Object.freeze(new Test(data))
}



// WEBPACK FOOTER //
// ./src/models/Test.js